import axios from 'api/axios'

export interface AgentAppReleaseData {
	appVersion: string
	storeUrl: string
	description: string
}

export const getAgentAppRelease = async (): Promise<AgentAppReleaseData> => {
	const { data } = await axios.get<AgentAppReleaseData>('api/agent-app/release')
	return data
}

export const updateAgentAppRelease = async (
	body: Partial<AgentAppReleaseData>
): Promise<AgentAppReleaseData> => {
	const { data } = await axios.patch<AgentAppReleaseData>(
		'api/agent-app/release',
		body
	)
	return data
}
